import { PaymentService } from '../../../../../../Service/PaymentService';
import { BasePanelController } from '../../../../../BaseUI/BasePanelController';
import { PaymentDetailPanelComponent } from './PaymentDetailPanelComponent';
import { FileService } from '../../../../../../Service/FileService';

/**
 * PaymentDetailPanelController
 * 請求詳細画面のコントローラー
 */
export class PaymentDetailPanelController extends BasePanelController {

	// 検査詳細画面に対応するコントローラー
	public combineView: PaymentDetailPanelComponent;

	/**
	 * getPaymentDetailData
	 * 請求詳細データ取得
	 * @param param オーダー番号
	 * @returns 請求詳細
	 */
	public async getPaymentDetailData(param: { view: any; paymentId: any }) {

		const svc = new PaymentService(param.view);
		const ret = await svc.getPaymentDetail(param.paymentId);

		return ret;

	}


	public async getPdfData(param: { view: any; fileInfoId: number }) {
		const svc = new FileService(param.view);
		return await svc.downloadFileUri(param.fileInfoId);
	}



}
